import React, { useContext } from "react";
import { IInteriorItem, IVec2d } from "../../services/WebApiClient";
import { FrontPosConverter } from "../../util/PosConverter";
import { EditorContext } from "../EditorCommon/EditorContext";


export function ItemWarning({ item }: { item: IInteriorItem }) {
    const ec = useContext(EditorContext);
    const convert = new FrontPosConverter(ec.cabinet.height!);

    const overCoverage = { x: 50, y: 20 };

    const blownUpItem = {
        size: { ...item.size },
        position: { ...item.position }
    };

    for (let dim of (['x', 'y'] as (keyof IVec2d)[])) {
        const sizeToAdd = overCoverage[dim];
        blownUpItem.size[dim] += sizeToAdd;
        blownUpItem.position[dim] -= (sizeToAdd / 2);
    }


    return (<rect {...convert.obj(blownUpItem)}
        fill="rgba(255,180,0,0.5)"
        style={{ pointerEvents: "none" }}
    />);
}
